import { render } from "./ContactFormApp.vue?vue&type=template&id=afba5ecc"
import script from "./ContactFormApp.vue?vue&type=script&lang=js"
export * from "./ContactFormApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__